"use client";

import { Box, Container, Flex } from "@chakra-ui/react";
import { Footer } from "../../landing/_components/Footer";
import { useLocale, useTranslations } from "next-intl";
import { NextLink } from "@/_components/ui/NextLink";
import { HelpCenterHeader } from "./HelpCenterHeader";
import { HELP_CENTER_IDS } from "../_constants/help-center.ids";

interface HelpCenterLayoutShellProps {
  children: React.ReactNode;
}

export function HelpCenterLayoutShell({
  children,
}: HelpCenterLayoutShellProps) {
  const locale = useLocale();
  const tFooter = useTranslations("landing.footer");
  return (
    <Box
      id={HELP_CENTER_IDS.layout.root}
      minH="100dvh"
      display="flex"
      flexDirection="column"
      bg="neutral.50"
    >
      <HelpCenterHeader />

      <Box
        id={HELP_CENTER_IDS.layout.main}
        as="main"
        role="main"
        flex={1}
        py={{ base: "4.125rem", md: "3.25rem" }}
      >
        <Box id={HELP_CENTER_IDS.layout.content}>{children}</Box>
      </Box>

      <Box id={HELP_CENTER_IDS.layout.footer} bg="neutral.900">
        <Container
          id={HELP_CENTER_IDS.layout.footerMain}
          maxW="full"
          mx="auto"
          px={{ base: 4, md: 0 }}
        >
          <Footer theme="dark" />
        </Container>
        <Box
          id={HELP_CENTER_IDS.layout.footerPolicyLinks}
          borderTop="1px solid"
          borderColor="whiteAlpha.100"
          py={4}
          px={{ base: 4, md: 10 }}
        >
          <Container maxW="1000px" px={0}>
            <Flex
              id={HELP_CENTER_IDS.layout.footerLinksRow}
              gap={6}
              justify="center"
              flexWrap="wrap"
            >
              <NextLink
                id={HELP_CENTER_IDS.layout.footerLinkTerms}
                href={`/${locale}/help-center/terms-of-service`}
                fontSize="xs"
                color="whiteAlpha.400"
                _hover={{ color: "white" }}
                transition="color 0.2s"
              >
                {tFooter("terms_conditions")}
              </NextLink>
              <NextLink
                id={HELP_CENTER_IDS.layout.footerLinkPrivacy}
                href={`/${locale}/help-center/privacy-policy`}
                fontSize="xs"
                color="whiteAlpha.400"
                _hover={{ color: "white" }}
                transition="color 0.2s"
              >
                {tFooter("privacy_policy")}
              </NextLink>
              <NextLink
                id={HELP_CENTER_IDS.layout.footerLinkRefund}
                href={`/${locale}/help-center/refund-policy`}
                fontSize="xs"
                color="whiteAlpha.400"
                _hover={{ color: "white" }}
                transition="color 0.2s"
              >
                {tFooter("refund_policy")}
              </NextLink>
            </Flex>
          </Container>
        </Box>
      </Box>
    </Box>
  );
}
